module.exports = __webpack_public_path__ + "static/Logo_aws-49de07c73f3f0aa203dbd9328f9fa4f7.png";